import React from 'react';
import Timeline from './Timeline';
import { motion } from 'framer-motion';
import SEO from './SEO';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

export default function AboutPage() {
  const { t } = useLanguage();
  const { theme } = useTheme();

  return (
    <div className={`${theme === 'dark' ? 'bg-dark-bg' : 'bg-off-white'} min-h-screen py-24`}>
      <SEO
        title={t('about.title')}
        description={t('about.subtitle')}
        canonicalPath="/sobre-nosotros"
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16 relative z-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className={`text-5xl md:text-7xl font-bold ${theme === 'dark' ? 'text-white' : 'text-charcoal'} mb-8 tracking-tighter`}
        >
          {t('about.title')}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className={`text-xl ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'} font-light max-w-2xl mx-auto`}
        >
          {t('about.subtitle')}
        </motion.p>
      </div>

      <Timeline />
    </div>
  );
}